import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Checkbox } from 'semantic-ui-react';

import { userAgenda } from '../../../agenda/store/agenda.selectors';
import UserRegistrationModal from '../../../authentication/components/UserRegistrationModal/UserRegistrationModal';
import { useIsAnonymous } from '../../../profile/hooks';
import { workshopProptypes } from '../../../propTypes';
import { getString } from '../../../utils';
import RegistrationConditionMessage from '../../../workshops/components/RegistrationConditionMessage';
import { useWorkshopSessionRegistration } from '../../store/workshopSessions.hooks';
import './WorkshopSessionRegitrationButton.scss';

const translationPrefix = 'workshops.workshop';

const WorkshopSessionRegistrationButton = ({ session, registration, showCheckbox }) => {
  const {
    isWorkshopSessionFull,
    isWorkshopSessionEnded,
    loading,
    registrationState,
    registerWorkshopSession,
    unregisterWorkshopSession,
  } = useWorkshopSessionRegistration(session);
  const { t } = useTranslation();
  const isAnonymous = useIsAnonymous();
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  if (!session) return null;

  if (isWorkshopSessionEnded) {
    return <p>{getString(`${translationPrefix}.workshop-ended`)}</p>;
  }
  if (!registration && registrationState.state === 'CLOSED_REGISTRATION_CONDITION') {
    return (
      <div className="WorkshopSessionRegistationButton__ConditionNotMet">
        <RegistrationConditionMessage />
      </div>
    );
  }
  if (registration) {
    return (
      <div className="WorkshopSessionRegistationButton__AlreadyRegistered">
        <Button
          as="a"
          className="unregister-button"
          onClick={unregisterWorkshopSession}
          loading={loading}
          disabled={loading}
        >
          <span> {getString(`${translationPrefix}.unregister`)}</span>
        </Button>
      </div>
    );
  }

  return (
    <div className="WorkshopSessionRegistationButton__Unregistered">
      {session.startDate ? (
        <div>
          {!isWorkshopSessionFull && (
            <>
              {showCheckbox && (
                <Checkbox
                  label={
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label>{t(`${translationPrefix}.share-info-with-exhibitor`)}</label>
                  }
                  onClick={(_e, { checked }) => setIsChecked(checked)}
                  checked={isChecked}
                  style={{ marginBottom: 5 }}
                />
              )}
              <Button
                primary
                className="register-button"
                floated="right"
                onClick={() => (isAnonymous ? setIsOpen(true) : registerWorkshopSession())}
                loading={loading}
                disabled={loading || (showCheckbox && !isChecked)}
              >
                {getString(`${translationPrefix}.register`)}
              </Button>
            </>
          )}
        </div>
      ) : (
        <p className="registrations-not-yet-open-label">
          {getString(`${translationPrefix}.registrations-not-yet-open`)}
        </p>
      )}
      {isOpen && <UserRegistrationModal onClose={() => setIsOpen(false)} />}
    </div>
  );
};

WorkshopSessionRegistrationButton.defaultProps = {
  session: undefined,
  registration: undefined,
  showCheckbox: false,
};

WorkshopSessionRegistrationButton.propTypes = {
  session: PropTypes.shape(workshopProptypes),
  registration: PropTypes.object,
  showCheckbox: PropTypes.bool,
};

export default connect((state, props) => ({
  registration: state.registrations.registrationsById[props.session?.workshopId],
  agenda: userAgenda(state),
}))(WorkshopSessionRegistrationButton);
